﻿function groupTooltipsByContent(tooltipElements) {

    if (tooltipElements.length === 0) {
        return [];
    }

    const citations = [];

    for (const tooltip of tooltipElements) {
        const tooltipText = tooltip.querySelector('.tooltip-hover-text').innerHTML.trim();
        const existingCitation = citations.find(c => c.text === tooltipText);

        if (existingCitation) {
            existingCitation.elements.push(tooltip);
        } else {
            citations.push({
                text: tooltipText,
                elements: [tooltip]
            });
        }
    }

    return citations;
}


export function setCitationText() {
    const tooltipElements = [...document.querySelectorAll('.tooltip')];
    const groupedTooltips = groupTooltipsByContent(tooltipElements);

    if (groupedTooltips.length === 0) {
        return;
    }

    const referenceBlock = document.querySelector('.references-block');
    referenceBlock.style.display = 'revert';
    const referenceBlockList = referenceBlock.querySelector('ol');

    for (let i = 0; i < groupedTooltips.length; i++) {
        const elementId = "reference-" + (i + 1);
        const listElement = document.createElement("li");
        listElement.innerHTML = groupedTooltips[i].text;
        listElement.id = elementId;
        referenceBlockList.appendChild(listElement);

        for (const tooltip of groupedTooltips[i].elements) {
            const tooltipIcon = tooltip.querySelector('.tooltip-icon');
            const tooltipCitation = tooltip.querySelector('.tooltip-citation');
            tooltipIcon.style.display = 'none';
            tooltipCitation.style.display = 'inline-block';
            tooltipCitation.innerHTML = i + 1;
            tooltipCitation.href = '#' + elementId;
        }
    }

    // remove trailing whitespace that umbraco adds right before a macro inside a paragraph
    for (let parent of tooltipElements.map(t => t.parentElement)) {
        const lastIdx = parent.childNodes.length - 1;
        for (let i = 0; i < parent.childNodes.length; i++) {
            const node = parent.childNodes[i];

            // if this is a block of text preceding a tooltip: remove the last whitespace
            if(node.nodeType === Node.TEXT_NODE) {
    
                // element with tooltip class is three elements after the text-block
                if(i + 3 < lastIdx && parent.childNodes[i + 3].classList.contains('tooltip')) {
                    node.textContent = node.textContent.replace(/\s$/, "");
                }
            }
        }
    }
}